import apiClient from "../config/apiClient";


export const fetchAllRadiologyTest = async ({ q = "", limit = 8, page = 1 } = {}) => {
    const user = window.localStorage.getItem("token");
    const token = user;
    const params = new URLSearchParams();

    if (q) {
      params.set("q", q);
    }
    params.set("limit", String(limit));
    params.set("page", String(page));
    const queryString = params.toString().replace(/&/g, "%26");

    return await apiClient.get(`/public/portal?url=services/scans${queryString ? `?${queryString}` : ""}`, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  };
